import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'metersToKm'
})
export class MetersToKmPipe implements PipeTransform {

  transform(value: number, decimals: number = 1): string {
    if (isNaN(value)) return '';
    const km = value / 1000;
    return `${km.toFixed(decimals)} km`;
  }

}